import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CoreModule } from './@core';
import { SidebarModule } from 'primeng/sidebar';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ApiService } from './services/api.service';
import { AuthenticationService } from './services/authentication.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DatePipe, registerLocaleData } from '@angular/common';
import { AuthModule, AbstractSecurityStorage } from 'angular-auth-oidc-client';
import { OIDCStorageService } from './services/oidcstorage.service';
import { environment } from '../environments/environment';
import localeIS from '@angular/common/locales/is';
registerLocaleData(localeIS);

@NgModule({
  imports: [
    OverlayPanelModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    SidebarModule,
    AppRoutingModule,
    NgxPermissionsModule.forRoot(),
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule.forRoot({
      config: {
        authority: environment.azureAdB2C.authority,
        authWellknownEndpointUrl: environment.azureAdB2C.authWellknownEndpointUrl,
        redirectUrl: `${window.location.origin}/auth-callback`,
        postLogoutRedirectUri: `${window.location.origin}/login`,
        clientId: environment.azureAdB2C.clientId,
        scope: 'openid offline_access profile ' + environment.azureAdB2C.apiscope,
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        ignoreNonceAfterRefresh: true,
        maxIdTokenIatOffsetAllowedInSeconds: 600,
        issValidationOff: false, // this needs to be true if using a common endpoint in Azure
        autoUserInfo: false,
        //logLevel: LogLevel.Debug,
        customParamsAuthRequest: {
          prompt: 'select_account', // login, consent
        },
        renewTimeBeforeTokenExpiresInSeconds: 10,
        secureRoutes: [environment.apiUrl],
      },
    }),
  ],
  declarations: [AppComponent],
  providers: [
    ApiService,
    AuthenticationService,
    MessageService,
    ConfirmationService,
    DatePipe,
    { provide: LOCALE_ID, useValue: 'is-IS' },
    { provide: AbstractSecurityStorage, useClass: OIDCStorageService },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
